module.exports = __webpack_public_path__ + "static/media/file powerpoint.9ca72bdb.svg";